export default function formatName(fullName: string): string {
  if (!fullName.trim()) return "";

  const parts = fullName.toLowerCase().trim().split(/\s+/);

  const cap = (w: string) => w.charAt(0).toUpperCase() + w.slice(1);

  if (parts.length === 1) {
    return cap(parts[0]);
  }

  if (parts.length === 2) {
    return parts.map(cap).join(" ");
  }

  const firstName = cap(parts[0]);
  const firstLastName = cap(parts[1]);

  return `${firstName} ${firstLastName}`;
}
